import { render, staticRenderFns } from "./CategoryView.vue?vue&type=template&id=1beafa2f&lang=pug&"
import script from "./CategoryView.vue?vue&type=script&lang=js&"
export * from "./CategoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports